"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateAccountAlertChannelsAction, type AccountAlertChannelsView } from "@/server-actions/alert-channels"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { alertChannelsQueryKey } from "@/hooks/queries/alert-channels"
import { qualityDigestSettingsQueryKey } from "@/hooks/queries/conversation-quality"
import { useTranslations } from "next-intl"


export function useUpdateAccountAlertChannelsMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsAlertChannels")

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: { channelIds: string[] }): Promise<AccountAlertChannelsView> => {
      const result = await withQueryHandling(updateAccountAlertChannelsAction(input), {
        loading: tUi("savingAlertChannels"),
        success: tUi("alertChannelsSaved"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: (data) => {
      queryClient.setQueryData(alertChannelsQueryKey, data)
      // An unconfigured digest shows these channels as its own.
      return queryClient.invalidateQueries({ queryKey: qualityDigestSettingsQueryKey })
    },
  })
}
